import { PERIOD } from '../../constants/shared/CommonConstants';
import { PDF_TITLE_KEYS } from '../../constants/shared/PdfGenerationConstants';

export const isAvailableToyPdfByMeasure = (
    selectedPeriod,
    licensingInfo,
    studentsByGrade,
    measure,
    license,
    gradeToMeasureMapper = [],
) => {
    // TODO We get license for class which doesn't consist it becasuse licensing logic works for the institution level
    // https://amplify-education.atlassian.net/browse/CAT-28453
    const gradesAvailable = gradeToMeasureMapper.reduce((acc, { key, measures }) => {
        if (measures.includes(measure)) {
            acc.push(key);
        }

        return acc;
    }, []);

    const hasAvailableGrade = !!studentsByGrade.find(({ grade }) =>
        gradesAvailable.includes(grade),
    );

    return (
        licensingInfo.includes(license) && selectedPeriod !== PERIOD.SUMMARY && hasAvailableGrade
    );
};

export const getPdfAvailabilityMapper = pdfAvailability =>
    pdfAvailability.reduce((acc, { item, isNew }) => {
        acc[PDF_TITLE_KEYS[item]] = isNew;

        return acc;
    }, {});
